import SenderDetailsValidator from "../../setting/services/senderDetailValidator";

export default class eventSettings {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/event/directives/event-settings.html'),
            controller: EventSettingsCtrl,
            controllerAs: 'settings'
        }
    }
};

class EventSettingsCtrl {
    constructor($scope, $filter, $timeout, SweetAlert, Sogeti, Event, Events, Template, SenderDetailsValidator, Campaign) {
        this._scope = $scope;
        this._translator = $filter('translate');

        this.languages = [
            {code: 'sv', language: 'Swedish'},
            {code: 'fr', language: 'French'},
            {code: 'en', language: 'English'},
            {code: 'no', language: 'Norwegian'},
        ];

        this.alerter = SweetAlert;
        this.sogeti = Sogeti;
        this.templateRepo = Template;
        this.eventHandler = Events;
        this.eventRepo = Event;
        this.emailValidator = SenderDetailsValidator;
        this.campaignRepo = Campaign;

        this.minimumDate = moment();
        this.locationSettings = false;
        this.loaded = false;
        this.originalTopic = 0;
        this.showOverlay = false;

        this._scope.$on('event:locationSettings', (event, data) => {
            this.locationSettings = data;
        });

        this._scope.$on('event:settings:show', (event, data) => {
            this.showOverlay = true;
            this.event = data.event;

            if (!this.event.metadata.data) {
                this.event.metadata.data = {};
            }

            if (this.event.event_status_id === 2) {
                this.event.metadata.data.start_date_changed_to = this.event.start_date;
                this.event.metadata.data.end_date_changed_to = this.event.end_date;
            }

            this.originalTopic = this.event.metadata ? angular.copy(this.event.metadata.data.topic) : null;
            this.loadedTags = this.event.tags;
            this.loadedSubscribers = this.event.subscribers;
            this.loaded = true;
            this.isSogetiAccount = this.sogeti.isSogetiAccount(this.event.account_id);
            this.invitationScheduleDateFormatted = null;

            this.event.metadata.data.additional_time_info = this.event.metadata.data.additional_time_info || null;
            this.event.metadata.data.place = this.event.metadata.data.place || null;
            this.event.metadata.data.responsible = this.event.metadata.data.responsible || null;

            if (this.isSogetiAccount) {
                $timeout(() => {
                    this._scope.$broadcast('event:settings:setupLocationSettings', {event: this.event});
                }, 100);

                if (!this.topics) {
                    this.templateRepo.allTypesByLanguage().then((types) => {
                        this.topics = [];

                        angular.forEach(types, (templateType) => {
                            if (templateType.id > 100) {
                                this.topics.push(templateType);
                            }
                        });
                    });
                }
            }

            let invitationCampaign = this.event.campaigns.filter(campaign => campaign.pivot["event_dispatcher_type_id"] === 1);

            if (invitationCampaign) {
                this.campaignRepo.getSchedule(invitationCampaign[0].id).then((schedule) => {
                    this.invitationScheduleDateFormatted = moment(schedule.date + " " + schedule.time.hour + ":" + schedule.time.minutes);
                });
            }
        });
    }

    changeStartDate() {
        let newStartDate = this.event.start_date;

        if (moment(newStartDate) > moment(this.event.end_date)) {
            this.event.end_date = moment(newStartDate);
        }
    }

    close() {
        this.showOverlay = false;
        this._scope.$emit('event:settings:closed');
    };

    saveSettings() {
        if (moment(this.event.start_date) > moment(this.event.end_date)) {
            return this.alerter.swal({
                title: this._translator('EVENT:FLASH:START_BEFORE_END_HEADER'),
                text: this._translator('EVENT:FLASH:START_BEFORE_END_BODY'),
                type: 'error'
            });
        }

        if (typeof this.event.pages['episubscription'] !== 'undefined') {
            let eventWebPageData = angular.fromJson(this.event.pages['episubscription'].data);
            let eventWebPagePublishAt = moment(eventWebPageData.metadata.publish_at);
            if (eventWebPagePublishAt > moment(this.event.start_date)) {
                return this.alerter.swal({
                    title: this._translator('EVENT:FLASH:START_BEFORE_END_HEADER'),
                    text: this._translator('EVENT:FLASH:INCORRECT_EVENT_TIME'),
                    type: 'error'
                });
            }
        }

        if (this.invitationScheduleDateFormatted && this.invitationScheduleDateFormatted > moment(this.event.start_date)) {
            return this.alerter.swal({
                title: this._translator('EVENT:FLASH:START_BEFORE_END_HEADER'),
                text: this._translator('EVENT:FLASH:INCORRECT_EVENT_TIME'),
                type: 'error'
            });
        }

        if (this.eventPublished()) {
            if (moment(this.event.metadata.data.start_date_changed_to) > moment(this.event.metadata.data.end_date_changed_to)) {
                return this.alerter.swal({
                    title: this._translator('EVENT:FLASH:START_BEFORE_END_HEADER'),
                    text: this._translator('EVENT:FLASH:START_BEFORE_END_BODY'),
                    type: 'error'
                });
            }

            this.alerter.swal({
                title: this._translator('EVENT:UPDATE_CONFIRM_TITLE'),
                text: this._translator('EVENT:UPDATE_CONFIRM_TEXT'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: this._translator('GLOBAL:YES'),
                cancelButtonText: this._translator('GLOBAL:NO')
            }, (isConfirm) => {
                if (isConfirm) {
                    this.updateEvent(true);
                }
            });
        } else {
            this.updateEvent();
        }
    };

    eventPublished() {
        return this.event.event_status_id === 2;
    }

    updateEvent(updatedDatePlace) {
        this.eventRepo.update(this.event).then((response) => {
            this.event = response.data;
            this.showOverlay = false; // Close the modal.
            this._scope.$emit('event:settings:saved', {event: this.event});
            this.eventHandler.flashEvent('notification', this._translator('EVENT:FLASH:UPDATED'));

            if (updatedDatePlace) {
                this.eventRepo.resendInvitations(this.event.id);
            }
        }, (error) => {
            if (error.data.error === 'Invalid email') {
                return this.eventHandler.flashEvent('error', this._translator('SETTING:ERRORS:EMAIL'));
            } else {
                return this.eventHandler.flashEvent('error', this._translator('GLOBAL:ERROR:DEFAULT'));
            }
        });
    }
}
